import React from "react";
import { Link } from "react-router-dom";
import NoData from "../../NoData";
import SaleItem from "./SaleItem";

const RecentSales = ({ recentSales }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-3">
      <div className="px-4 py-3 border-b border-gray-100">
        <h5 className="flex justify-between items-center flex-grow text-lg font-semibold text-gray-800">
          <span>Recent Sales</span>
          <Link
            className="text-xs font-medium text-blue-600 hover:text-blue-700 transition-colors"
            to="/sales/list"
          >
            View All
          </Link>
        </h5>
      </div>
      <div className="p-2.5">
        <ul className="space-y-2">
          {recentSales?.map((sale, index) => (
            <SaleItem key={index} sale={sale} />
          ))}
        </ul>
        {recentSales?.length <= 0 && <NoData />}
      </div>
    </div>
  );
};

export default RecentSales;